<template>
  <div class="zk-breadcrumb">
    <slot></slot>
  </div>
</template>
<script>
  export default {
    name: 'ZkBreadcrumb',

    props: {
      separator: {
        type: String,
        default: '/'
      }
    }
  };
</script>



// WEBPACK FOOTER //
// breadcrumb.vue?07be5346